import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearRecords,
    clearUpdateRecordError,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchRecordsStart,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    clearAddRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    addRecordToBottom,
    updateRecord,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord
} from "../utility";

const initialState = {
    records: [],
    record: null,
    isLoading: false,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    error: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    searchParams: {},
    pagination: {},
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_CONTENTS_START: return fetchRecordsStart(state);
        case actionTypes.FETCH_CONTENTS_SUCCESS: return fetchRecordsSuccess(state, action.payload);
        case actionTypes.FETCH_CONTENTS_FAIL: return fetchRecordsFail(state, action.payload);
        case actionTypes.CLEAR_CONTENTS: return clearRecords(state);
        case actionTypes.FETCH_CONTENT_START: return fetchRecordStart(state);
        case actionTypes.FETCH_CONTENT_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_CONTENT_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_CONTENT: return clearRecord(state);
        case actionTypes.ADD_CONTENT: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_CONTENT_START: return addRecordStart(state);
        case actionTypes.ADD_CONTENT_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_CONTENT_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_CONTENT_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_CONTENT_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_CONTENT_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_CONTENT: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_CONTENT: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_CONTENT_START: return updateRecordStart(state);
        case actionTypes.UPDATE_CONTENT_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_CONTENT_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_CONTENT_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_CONTENT_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_CONTENT_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_CONTENT: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;